import api from './api'
import axios from 'axios'

export const salesService = {
  async updateSale(id, data) {
    if (!data.itemnumber) {
      throw new Error('Item number is required')
    }
    return await api.put(`/sales/${id}`, {
      itemnumber: data.itemnumber,
      quantity: data.quantity,
      shippingname: data.shippingname,
      shippingstreet1: data.shippingstreet1,
      shippingstreet2: data.shippingstreet2 || '',
      shippingstreet3: data.shippingstreet3 || '',
      phone: data.phone,
      city: data.city,
      state: data.state,
      zip: data.zip,
      country: data.country,
      Vendor: data.Vendor,
      ActualMyCost: data.ActualMyCost || 0,
      ActualShipping: data.ActualShipping || 0,
      amazonfees: data.amazonfees || 0,
      ebayfees: data.ebayfees || 0,
      Note: data.Note || '',
      submitted: data.submitted || '',
      ebayorderid: data.ebayorderid || '',
      vendorAccount: data.vendorAccount || '',
      vendorLink: data.vendorLink || '',
      invoice_id: data.invoice_id || '',
      ignore_vendor_tracking_number: data.ignore_vendor_tracking_number ? 1 : 0,
      ignore_vendor_invoice_check: data.ignore_vendor_invoice_check ? 1 : 0,
    })
  },

  async getSale(id) {
    return await api.get(`/sales/${id}`)
  },

  async getSalesEbayAccounts() {
    return await api.get('/sales/ebay-accounts')
  },

  async cancelSale(id) {
    return await api.post(`/sales/${id}/cancel`)
  },

  async sendMessage(id, params) {
    return await api.post(`/sales/${id}/send-message`, params)
  },

  async getSales(params) {
    const queryParams = {
      page: params.page || 1,
      per_page: 25
    }
    
    if (params.filters) {
      queryParams.filters = params.filters
    }
    
    if (params.time_filter && params.time_filter !== 'all') {
      queryParams.time_filter = params.time_filter
    }
    
    if (params.store) {
      queryParams.store = params.store
    }
    
    return await api.get('/sales', { params: queryParams })
  },

  async deleteSales(saleIds) {
    return await api.delete('/sales', { data: { ids: saleIds } })
  },

  async getDelayedShipments(page = 1, params = {}) {
    return await api.get('/sales', {
      params: {
        page,
        ...params,
        delayed_shipments: true
      }
    })
  },

  async getLateShipments(page = 1, params = {}) {
    return await api.get('/sales', {
      params: {
        page,
        ...params,
        late_shipments: true
      }
    })
  },

  async exportDelayedShipments(saleIds) {
    const response = await axios.post(`${api.defaults.baseURL}/sales/delayed-shipments`, {
      ids: saleIds
    }, {
      responseType: 'blob',
      headers: api.defaults.headers
    })
    return response.data
  },

  async updateTracking(id, trackingNumber, trackingService = '', ignoreVendor = null) {
    return await api.post(`/sales/${id}/update-tracking`, {
      tracking_number: trackingNumber,
      tracking_service: trackingService,
      ...(ignoreVendor ? {ignore_vendor: ignoreVendor}:{})
    })
  },

  async submitTrackingRequest(data) {
    return await api.post(`/sales/tracking-request-email`, data)
  },

  async exportSales(params) {
    const response = await axios.get(`${api.defaults.baseURL}/sales`, {
      params,
      responseType: 'blob',
      headers: api.defaults.headers
    })
    return response.data
  },

  async exportNewSales(store = null) {
    const response = await axios.get(`${api.defaults.baseURL}/sales/export-new`, {
      params: store ? { store } : {},
      responseType: 'blob',
      headers: api.defaults.headers
    })
    return response.data
  },

  async importShippingData(formData) {
    return await api.post('/sales/import-shipping', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },

  async importCostData(formData) {
    return await api.post('/sales/import-cost', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },

  async importFeesData(formData) {
    return await api.post('/sales/import-fees', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },

  async exportYearlySales(year, email) {
    return await api.post(`/sales/yearly/${year}`, {
      email
    })
  },

  async downloadZipFile(jobId) {
    const response = await axios.get(`${api.defaults.baseURL}/sales/download-export/${jobId}`, {
      responseType: 'blob',
      headers: api.defaults.headers
    })
    return response.data
  }
} 